import { showToast } from '../../collections/CollectionUI.js';

export function initEditModal() {
    const editModal = document.getElementById('edit-collection-modal');
    const editForm = document.getElementById('edit-collection-form');
    const closeBtn1 = document.getElementById('close-edit-modal');
    const closeBtn2 = document.getElementById('cancel-edit-collection');

    if (!editModal || !editForm) return;

    /* Close button handlers */
    [closeBtn1, closeBtn2].forEach((button) => {
        button?.addEventListener('click', () => this.hideEditModal());
    });

    /* Close on overlay click */
    editModal.addEventListener('click', (event) => {
        if (event.target === editModal) {
            this.hideEditModal();
        }
    });

    /* Close on ESC key */
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !editModal.classList.contains('hidden')) {
            this.hideEditModal();
        }
    });

    /* Form submit handler */
    editForm.addEventListener('submit', (event) => this.handleEditSubmit(event));
}

export function showEditModal(collectionId) {
    const collection = this.collections.find((coll) => coll.id === collectionId);
    
    if (!collection) {
        showToast('error', 'Không tìm thấy collection');
        return;
    }

    const modal = document.getElementById('edit-collection-modal');
    if (!modal) return;

    /* Populate form fields */
    document.getElementById('edit-collection-id').value = collection.id;
    document.getElementById('edit-collection-name').value = collection.name || '';
    document.getElementById('edit-collection-description').value = collection.description || '';
    
    /* Handle tags */
    const tagsInput = document.getElementById('edit-collection-tags');
    if (collection.tags && Array.isArray(collection.tags)) {
        tagsInput.value = collection.tags.join(', ');
    } else {
        tagsInput.value = '';
    }
    
    /* Handle public checkbox */
    document.getElementById('edit-collection-public').checked = collection.is_public || false;

    /* Show modal */
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    document.body.style.overflow = 'hidden';

    /* Focus on name input */
    document.getElementById('edit-collection-name')?.focus();
}

export function hideEditModal() {
    const modal = document.getElementById('edit-collection-modal');
    modal?.classList.add('hidden');
    modal?.classList.remove('flex');
    document.body.style.overflow = '';

    /* Reset form */
    document.getElementById('edit-collection-form')?.reset();
}

export async function handleEditSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const submitBtn = document.getElementById('submit-edit-collection');
    const btnText = submitBtn?.querySelector('.edit-btn-text');
    const btnLoading = submitBtn?.querySelector('.edit-btn-loading');

    /* Get form data */
    const collectionId = parseInt(document.getElementById('edit-collection-id').value, 10);
    const name = document.getElementById('edit-collection-name').value.trim();
    const description = document.getElementById('edit-collection-description').value.trim();
    const tagsString = document.getElementById('edit-collection-tags').value.trim();
    const isPublic = document.getElementById('edit-collection-public').checked;

    /* Validation */
    if (!name) {
        showToast('error', 'Vui lòng nhập tên collection');
        return;
    }

    if (name.length > 255) {
        showToast('error', 'Tên collection không được vượt quá 255 ký tự');
        return;
    }

    /* Parse tags */
    const tags = tagsString
        ? tagsString.split(',').map((tag) => tag.trim()).filter((tag) => tag.length > 0)
        : [];

    /* Disable submit button */
    if (submitBtn) {
        submitBtn.disabled = true;
        btnText?.classList.add('hidden');
        btnLoading?.classList.remove('hidden');
    }

    try {
        const response = await this.api.updateCollection(collectionId, {
            name,
            description: description || '',
            tags,
            is_public: isPublic
        });

        if (response && response.id) {
            showToast('success', 'Cập nhật collection thành công!');
            this.hideEditModal();
            this.loadCollections(); /* Reload collections list */
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.error('Error updating collection:', error);
        showToast('error', error.message || 'Không thể cập nhật collection');
    } finally {
        /* Re-enable submit button */
        if (submitBtn) {
            submitBtn.disabled = false;
            btnText?.classList.remove('hidden');
            btnLoading?.classList.add('hidden');
        }
    }
}
